import { getApiUrl, getSiteName } from 'config/appConfig';
import { ThemeConfig } from 'types/storefront';

export const resolveSiteName = (theme?: ThemeConfig | null): string =>
  theme?.siteName?.trim() || getSiteName();

export const digitsOnly = (value?: string): string => (value ?? '').replace(/\D/g, '');

export const buildWhatsAppUrl = (whatsapp?: string): string | null => {
  const digits = digitsOnly(whatsapp);
  return digits ? `https://wa.me/${digits}` : null;
};

/** Resuelve logo/favicon: URL absoluta, data URI o ruta relativa del API. */
export const resolveStoreMediaUrl = (url?: string | null): string => {
  const trimmed = url?.trim() ?? '';
  if (!trimmed) return '';
  if (
    trimmed.startsWith('http://') ||
    trimmed.startsWith('https://') ||
    trimmed.startsWith('data:') ||
    trimmed.startsWith('blob:')
  ) {
    return trimmed;
  }
  if (trimmed.startsWith('/')) {
    return `${getApiUrl().replace(/\/$/, '')}${trimmed}`;
  }
  return trimmed;
};
